import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IUserPreferences } from 'models/user/userpreferences';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { RightColumnPortalPage, PortalPageSection, PageTitle, Paragraph } from 'components/PortalStructure';
import { ManageUserWrapper } from 'containers';
import { Label } from 'components';
require('./style.css');

interface IProps {
	userPreferences: IUserPreferences;
	t?: (key: string) => string;
}

@connect(
	(state: IStore) => ({
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({ dispatch }),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class Wallet extends React.Component<IProps, {}> {
	public render() {
		const { t } = this.props;
		const { tokenBalance } = this.props.userPreferences;
		return (
			<ManageUserWrapper>
				<RightColumnPortalPage>
					<PageTitle title={t('User_Wallet_Title')} />
					<div className="userWalletComponent">
						<PortalPageSection title={t('User_Wallet_MyBalance')}>
							<div className="row">
								<div className="col-md-12">
									<Paragraph text={t('User_Wallet_MyBalance_Desc')} />
								</div>
							</div>

							<div className="row">
								<div className="col-md-12">
									<Label text={t('User_Wallet_AccountBalance')} />
									<span className="balanceAmount">
										{tokenBalance} {t('User_Wallet_PPX')}
									</span>
								</div>
							</div>
						</PortalPageSection>
					</div>
				</RightColumnPortalPage>
			</ManageUserWrapper>
		);
	}
}

export { Wallet };
